import { navigate } from 'svelte-routing'
function nav(url) {
    window.gtag('config', 'G-K9SGV9RJF1', { page_path: url })
    navigate(url)
}

export { default as Link } from './Link.svelte'
export { nav as navigate }